import React from 'react';
import { useHistory } from 'react-router-dom';
import { I18n } from '@aws-amplify/core';
import { Row, Col } from 'antd';

import { Content } from './Content';
import { RosaResultProvider } from './context';
import { useRosaContext } from '../../context';
import { Title } from '@/components/Typography';
import { NextButton, PreviousButton } from '../../styles';
import { DownloadPDF } from './DownloadPDF/index';

export function Result() {
	const history = useHistory();
	const { onPreviousStep, isConsolidated } = useRosaContext();

	function redirectToReports(): void {
		history.push('/reporting/list/rosa');
	}

	return (
		<Row justify="center" gutter={[0, 20]}>
			<RosaResultProvider>
				<Col span={24} style={{ display: 'flex', justifyContent: 'space-between', padding: '0 1rem' }}>
					<Title level={4}>Results</Title>
					<DownloadPDF hiddenConsolidate />
				</Col>
				<Col span={24} style={{ padding: '1rem' }}>
					<Content />
				</Col>
			</RosaResultProvider>
			<Col span={24}>
				<Row justify="center" gutter={[30, 0]}>
					{!isConsolidated && (
						<Col>
							<PreviousButton type="ghost" onClick={onPreviousStep}>
								{I18n.get('Back')}
							</PreviousButton>
						</Col>
					)}
					<Col>
						<NextButton type="primary" onClick={redirectToReports}>
							{I18n.get('Close')}
						</NextButton>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
